var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 120,
    viewBox: "0 0 224 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5274_17821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135 32H89C86.2386 32 84 34.2386 84 37V83C84 85.7614 86.2386 88 89 88H135C137.761 88 140 85.7614 140 83V37C140 34.2386 137.761 32 135 32Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.618 75.7504C122.746 77.5922 124.213 78.9459 126.809 78.9459C128.989 78.9459 130.382 77.8562 130.382 76.3504C130.382 74.5459 128.951 73.9068 126.551 72.857L125.235 72.2926C121.438 70.6748 118.915 68.6482 118.915 64.3637C118.915 60.417 121.922 57.4126 126.622 57.4126C129.968 57.4126 132.373 58.577 134.106 61.6259L130.009 64.257C129.106 62.6393 128.133 62.0019 126.622 62.0019C125.081 62.0019 124.104 62.9797 124.104 64.257C124.104 65.8357 125.082 66.4748 127.339 67.4526L128.655 68.0162C133.126 69.9335 135.65 71.8882 135.65 76.2828C135.65 81.0206 131.929 83.6162 126.93 83.6162C122.043 83.6162 118.886 81.2873 117.341 78.2348L121.618 75.7504ZM103.028 76.2064C103.855 77.673 104.607 78.913 106.415 78.913C108.144 78.913 109.234 78.2366 109.234 75.6064V57.713H114.497V75.6775C114.497 81.1264 111.302 83.6064 106.639 83.6064C102.426 83.6064 99.9855 81.4259 98.7446 78.7997L103.028 76.2064Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5274_17821"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(84 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.252ab223dad171a87266f39999f61d2c.svg";
export { ForwardRef as ReactComponent };